import { render, staticRenderFns } from "./quantidade-turmas.vue?vue&type=template&id=2d094b7a&"
import script from "./quantidade-turmas.vue?vue&type=script&lang=js&"
export * from "./quantidade-turmas.vue?vue&type=script&lang=js&"
import style0 from "./quantidade-turmas.vue?vue&type=style&index=0&id=2d094b7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports